import React from "react";
import { Link } from "react-router-dom";
import { featuredCards, items } from "./data"; // or ../data/blogData

const ACCENT = "#BEE363";
const PRIMARY = "#1A4564";

export default function Blogs() {
  return (
    <section className="w-full bg-white mt-32">
      <div className="mx-auto w-[90%] 2xl:w-[70%]">
        <div className="grid gap-6 lg:grid-cols-12 items-start">
          {/* LEFT: 2 stacked big cards */}
          <div className="lg:col-span-7 h-full">
            <h2 className="mb-6 text-2xl font-extrabold tracking-tight text-[#1A4564]">
              Editor’s Picks
            </h2>

            <div className="grid grid-rows-2 gap-6 h-full">
              {featuredCards.map((featured, idx) => (
                <Link
                  key={featured.slug || idx}
                  to={`/ratgeber/${featured.slug}`}
                  className="block h-full"
                >
                  <article className="h-full group cursor-pointer">
                    <div className="h-full flex flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow">
                      {/* image */}
                      <div className="relative h-[180px] 2xl:h-[230px] shrink-0">
                        <img
                          src={featured.img}
                          className="h-full w-full object-cover"
                          alt={featured.title}
                        />

                        <span
                          className="absolute left-5 bottom-4 rounded-full px-3 py-1 text-xs 2xl:text-sm font-semibold"
                          style={{ backgroundColor: ACCENT, color: PRIMARY }}
                        >
                          {featured.tag}
                        </span>
                      </div>

                      {/* content */}
                      <div className="p-5 flex-1">
                        <div className="mb-2 text-xs 2xl:text-sm text-slate-500">
                          {featured.date}
                        </div>

                        <h2 className="text-lg font-extrabold text-[#1A4564] transition-opacity duration-200 group-hover:opacity-70">
                          {featured.title}
                        </h2>

                        <p className="mt-2 text-sm 2xl:text-lg text-slate-500 line-clamp-2 transition-opacity duration-200 group-hover:opacity-60">
                          {featured.excerpt}
                        </p>

                        <div className="mt-4 flex items-center gap-3">
                          <img
                            src={featured.authorAvatar}
                            alt={featured.authorName}
                            className="h-8 w-8 rounded-full object-cover"
                          />
                          <div className="text-sm font-semibold text-slate-700">
                            {featured.authorName}
                          </div>
                        </div>
                      </div>
                    </div>
                  </article>
                </Link>
              ))}
            </div>
          </div>

          {/* RIGHT: 4 stacked cards */}
          <div className="lg:col-span-5 h-full">
            <h2 className="mb-4 text-lg font-bold tracking-tight text-[#1A4564]">
              Latest Articles
            </h2>

            <div className="grid grid-rows-4 gap-6 h-full">
              {items.map((it, idx) => (
                <Link key={it.slug || idx} to={`/ratgeber/${it.slug}`} className="block h-full">
                  <article className="h-full group cursor-pointer">
                    <div className="h-full grid grid-cols-12 overflow-hidden rounded-2xl border border-slate-200 bg-white shadow">
                      {/* image */}
                      <div className="col-span-5 relative">
                        <img
                          src={it.img}
                          className="h-full w-full object-cover"
                          alt={it.title}
                        />

                        <span
                          className="absolute left-4 bottom-4 rounded-full px-3 py-1 text-[11px] font-semibold"
                          style={{ backgroundColor: ACCENT, color: PRIMARY }}
                        >
                          {it.tag}
                        </span>
                      </div>

                      {/* content */}
                      <div className="col-span-7 p-5 flex flex-col">
                        <div className="mb-2 text-[11px] text-slate-500">
                          {it.date}
                        </div>

                        <h3 className="text-sm 2xl:text-lg font-extrabold text-[#1A4564] transition-opacity duration-200 group-hover:opacity-70">
                          {it.title}
                        </h3>

                        <p className="mt-2 text-xs 2xl:text-lg text-slate-500 line-clamp-2 transition-opacity duration-200 group-hover:opacity-60">
                          {it.excerpt}
                        </p>

                        <div className="mt-auto pt-4 flex items-center gap-3">
                          <img
                            src={it.authorAvatar}
                            alt={it.authorName}
                            className="h-7 w-7 rounded-full object-cover"
                          />
                          <div className="text-xs 2xl:text-lg font-semibold text-slate-700">
                            {it.authorName}
                          </div>
                        </div>
                      </div>
                    </div>
                  </article>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
